import Cookies from "js-cookie";

let cookieValue = Cookies.get("selectedApp");
let selectedApp = null;
if (cookieValue) {
  selectedApp = parseInt(cookieValue);
}
const app = {
  state: {
    language: Cookies.get("language") || "en",
    selectedApp: selectedApp
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      state.language = language;
      Cookies.set("language", language);
    },
    SET_SELECTED_APP: (state, app) => {
      if (app) {
        state.selectedApp = app;
        Cookies.set("selectedApp", app);
      } else {
        state.selectedApp = null;
        Cookies.remove("selectedApp");
      }
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit("SET_LANGUAGE", language);
    },
    setSelectedApp({ commit }, app) {
      commit("SET_SELECTED_APP", app);
    }
  },
  getters: {
    language: state => state.language,
    selectedApp: state => state.selectedApp
  }
};

export default app;
